
import { useContext } from "react";
import { type TrackingProps, AnalyticsEventType, TrackingContext } from "../context/TrackingProvider";
import useLocale from "./useLocale";

const useTracking = () => {
  const { track: trackEvent } = useContext(TrackingContext);
	const { currentLanguage,  } = useLocale();

  const track = (input: TrackingProps) => {
    trackEvent(input);
  };

  const trackPageView = (slug: string) => {
    track({
			eventType: AnalyticsEventType.GPageVisit,
			data: {
				slug: window.location.pathname,
			},
			locale: currentLanguage,
		});
  };

  return { track, trackPageView };
};

export default useTracking;
